<template>
  <div v-if="entries.length > 0" class="pagefeed-section">
    <div class="container">
      <Header>
        <template v-slot>
          <span class="fbIcon">
            <img :src="'themes/frontend/assets/images/icon-fb2.png'" alt />
          </span>
          <span style="font-family: Arial">KYMCO Taiwan</span>
        </template>
      </Header>
    </div>
    <div class="container">
      <div class="grids">
        <div v-for="entry in entries" :key="entry.permalink_url" class="grid" :title="entry.message">
          <a :href="entry.permalink_url" class="entry entry--post link-zoom-image" target="_blank" data-ga-label="Facebook" :alt="entry.message">
            <div class="cover">
              <img :src="entry.full_picture" />
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
$colorActive = #27A7E1

.grids
  // For IE doesn't supports grid
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active)
    display flex
    flex-wrap wrap
    margin-right -1rem
    .grid
      flex 1 1 calc((100%/3) - 1rem)
      width calc((100%/3) - 1rem)
      margin-right 1rem
      margin-bottom 1rem
      @media (max-width 767px)
        flex 1 1 calc(100%/2 - 3rem)
  @supports (display: grid)
    display grid
    grid-gap 1rem
    grid-template-columns 33% 33% repeat(2, 1fr)
    grid-auto-rows minmax(10px, auto)
    margin 0
    .grid
      margin 0
    img
      width 100%
      height auto
    .grid:nth-child(1), .grid:nth-child(2)
      grid-row-start 1
      grid-row-end 3
    @media (max-width 767px)
      grid-template-columns 2.9fr .9fr 1.85fr
      .grid:nth-child(1)
        grid-row unset
        grid-column span 3
      .grid:nth-child(2)
        grid-row span 2
        grid-column span 2
      .grid:nth-child(6)
        grid-column span 2

.pagefeed-section
  // background-color #F8F8F8
  background-size cover
  padding-top 45px
  padding-bottom 60px
  @media (max-width 767px)
    padding-bottom 2rem
  /deep/ .owl-nav
    display none
  /deep/ .owl-dots
    margin 1.5rem auto
  /deep/ .owl-dot
    span
      width 2rem
      height 3px
      background white
      border-radius 25%
    &.active span
      background $colorActive

.slider
  margin 0 auto

.entry
  // max-width 315px
  height auto
  background white
  display block
  position relative
  &:after
    content ' '
    display block
    padding 1px
  .cover
    position relative
    height 0
    width 100%
    padding-top 100%
    border-radius 10px
    overflow hidden
    img
      object-fit cover
      position absolute
      width 100%
      height 100%
      top 0
      left 0
  .message
    margin 2.5rem 2rem
    font-size 1.2rem
    line-height 1.9
    overflow hidden
    text-overflow ellipsis
    display -webkit-box
    -webkit-line-clamp 4
    -webkit-box-orient vertical
    height 8rem
    padding-bottom .5rem
.fbIcon
  vertical-align middle
  img
    width 30px
    height 30px
    margin-right 1rem
</style>

<script>
import Header from './_header.vue'
export default {
  components: {
    Header,
  },
  props: {
    posts: Array,
  },
  computed: {
    entries() {
      return this.posts
    },
  },
}
</script>
